module.exports = __webpack_public_path__ + "static/media/immobilien_icon.df3eabed.svg";